/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetConfig200ResponseLastProducts
 */
export interface GetConfig200ResponseLastProducts {
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200ResponseLastProducts
     */
    pos: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200ResponseLastProducts
     */
    bookings: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200ResponseLastProducts
     */
    delivery: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200ResponseLastProducts
     */
    attendance: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200ResponseLastProducts
     */
    stock: boolean;
}

/**
 * Check if a given object implements the GetConfig200ResponseLastProducts interface.
 */
export function instanceOfGetConfig200ResponseLastProducts(value: object): value is GetConfig200ResponseLastProducts {
    if (!('pos' in value) || value['pos'] === undefined) return false;
    if (!('bookings' in value) || value['bookings'] === undefined) return false;
    if (!('delivery' in value) || value['delivery'] === undefined) return false;
    if (!('attendance' in value) || value['attendance'] === undefined) return false;
    if (!('stock' in value) || value['stock'] === undefined) return false;
    return true;
}

export function GetConfig200ResponseLastProductsFromJSON(json: any): GetConfig200ResponseLastProducts {
    return GetConfig200ResponseLastProductsFromJSONTyped(json, false);
}

export function GetConfig200ResponseLastProductsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetConfig200ResponseLastProducts {
    if (json == null) {
        return json;
    }
    return {
        
        'pos': json['pos'],
        'bookings': json['bookings'],
        'delivery': json['delivery'],
        'attendance': json['attendance'],
        'stock': json['stock'],
    };
}

export function GetConfig200ResponseLastProductsToJSON(json: any): GetConfig200ResponseLastProducts {
    return GetConfig200ResponseLastProductsToJSONTyped(json, false);
}

export function GetConfig200ResponseLastProductsToJSONTyped(value?: GetConfig200ResponseLastProducts | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pos': value['pos'],
        'bookings': value['bookings'],
        'delivery': value['delivery'],
        'attendance': value['attendance'],
        'stock': value['stock'],
    };
}

